import { createSlice } from '@reduxjs/toolkit';

import { type AlertAction, type AlertState } from './types';

const DEFAULT_TIMEOUT = 3000;

const name = 'alert';
const initialState: AlertState = {
    visible: false,
    message: '',
    closeTimestamp: Infinity,
};

export const alertSlice = createSlice({
    name,
    initialState,
    reducers: {
        addAlert(state, action: AlertAction) {
            const { message, timeout = DEFAULT_TIMEOUT } = action.payload;
            // TODO: We need to remove these Date instances from inside
            // our reducers, as they violate the "non-serializable" rule.
            const currentTime = new Date().getTime();

            state.message = message;
            state.visible = true;
            state.closeTimestamp = currentTime + timeout;
        },
        removeAlert(state) {
            state.visible = false;
            state.closeTimestamp = Infinity;
        },
        timestampAlert(state) {
            const currentTime = new Date().getTime();
            state.closeTimestamp = currentTime + DEFAULT_TIMEOUT;
        },
    },
});
